import React from 'react';
import { motion } from 'framer-motion';
import { Gift, Sparkles } from 'lucide-react';
interface BonusProps {
  number: string;
  title: string;
  image: string;
  description: string;
  variant?: 'standard' | 'horizontal';
}
export function BonusCard({
  number,
  title,
  image,
  description,
  variant = 'standard'
}: BonusProps) {
  const isHorizontal = variant === 'horizontal';
  return <motion.div initial={{
    opacity: 0,
    y: 20
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true
  }} className={`group relative flex h-full min-w-0 overflow-hidden rounded-2xl border border-[#e8decf] bg-white shadow-[0_16px_30px_-24px_rgba(46,16,101,0.8)] transition-[transform,box-shadow,border-color] duration-200 ease-out hover:-translate-y-1 hover:border-[#cfc0e4] hover:shadow-[0_22px_34px_-22px_rgba(46,16,101,0.5)] ${isHorizontal ? 'flex-row' : 'flex-col'}`} data-id="element-64" data-mp="20ezm9vso67od">
      {/* Gift Ribbon */}
      <div className="absolute top-0 left-0 z-30 pointer-events-none overflow-hidden w-32 h-32" data-id="element-65" data-mp="1x2ednewvmkvq">
        <div className="absolute top-6 -left-10 w-40 border-y border-white/20 bg-[#b78b31] py-1 text-center text-[10px] font-black uppercase tracking-widest text-white shadow-lg -rotate-45" data-id="element-66" data-mp="1s2icdnfkd7jv">
          ¡REGALO!
        </div>
      </div>

      <div className="absolute top-4 right-4 z-20 rounded-full bg-[#2e1065] p-2 text-white shadow-lg" data-id="element-67" data-mp="1icp7t6du9sp4">
        <Gift size={16} data-id="element-68" data-mp="1dfgqf80ilsox" />
      </div>

      <div className={`relative overflow-hidden bg-[#f5f0ea] ${isHorizontal ? 'w-2/5 shrink-0 self-stretch' : 'aspect-[4/3] w-full'}`} data-id="element-69" data-mp="19csfmus8qbpb">
        <img src={image} alt={title} className="h-full w-full object-contain transition-transform duration-200 ease-out group-hover:scale-[1.02]" data-id="element-70" data-mp="14fjvwprg1zly" />
        <div className="absolute inset-0 bg-[#2e1065]/10 opacity-0 transition-opacity duration-200 group-hover:opacity-100" data-id="element-71" data-mp="2yqp7cg8rvgbu" />
      </div>

      <div className={`relative flex flex-grow flex-col p-3 md:p-4 ${isHorizontal ? 'min-h-[176px]' : ''}`} data-id="element-72" data-mp="s37z764r7np5">
        <div className="mb-3 flex items-center gap-2" data-id="element-73" data-mp="wuq23zqc7ycr">
          <span className="rounded-full bg-[#eee5f7] px-3 py-1 text-[10px] font-black uppercase tracking-widest text-[#4b257a]" data-id="element-74" data-mp="i5ae2ri6y70r">
            BONO {number}
          </span>
          <Sparkles size={14} className="text-yellow-500 opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-75" data-mp="n20uxh1tl6n8" />
        </div>

        <h3 className={`mb-2 font-black leading-tight text-[#2e1065] transition-colors duration-200 group-hover:text-[#6b4fa0] ${isHorizontal ? 'text-[14px] md:text-base' : 'min-h-[4.5rem] text-[14px] md:min-h-[3rem] md:text-base'}`} data-id="element-76" data-mp="1frraluj3oglg">
          {title}
        </h3>
        <p className={`mb-3 flex-grow text-[11px] leading-relaxed text-[#665873] md:text-sm ${isHorizontal ? '' : 'min-h-[3rem]'}`} data-id="element-77" data-mp="3lnvdl9341ki5">
          {description}
        </p>
        <div className="mt-auto border-t border-[#eee5dc] pt-3" data-id="element-78" data-mp="28p1r0ctghn9y">
          <p className="text-[10px] font-black uppercase tracking-[0.1em] text-[#4b257a]" data-id="element-79" data-mp="23nm74o30lmt5">
            Incluido gratis
          </p>
        </div>
      </div>
    </motion.div>;
}